import axios from 'axios';

let prefix = "/creep-preset"

const CreepPresetApi = {
	listCreepPreset(payload) {
		return axios.get(prefix + "/list", { params: payload })
	},
}

export default CreepPresetApi;